"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadBundleComponents = exports.loadBundle = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../errors/RegistryError");
var evaluateBundle_1 = require("./evaluateBundle");
var loadAndEvaluate_1 = require("./loadAndEvaluate");
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
function getPendingModel(id, url) {
    var _this = this;
    var element = document.querySelector("script[src=\"" + url + "\"]");
    if (element) {
        return new Promise(function (resolve) {
            element.addEventListener('load', function () { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = resolve;
                            return [4 /*yield*/, getModel(id)];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            }); });
        });
    }
    return null;
}
function getModel(id) {
    var env = evaluateBundle_1.getEnvironment(id);
    var currentGlobal = evaluateBundle_1.getGlobal();
    if (typeof env.define === 'function') {
        return evaluateBundle_1.requireAMDModule(id);
    }
    else {
        var root = typeof self !== 'undefined' ? self : currentGlobal;
        return root[id];
    }
}
function loadBundle(transport, id, url, environmentLoader) {
    return __awaiter(this, void 0, void 0, function () {
        var model, pendingModel;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getModel(id)];
                case 1:
                    model = _a.sent();
                    if (model) {
                        return [2 /*return*/, model];
                    }
                    if (!isBrowser) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPendingModel(id, url)];
                case 2:
                    pendingModel = _a.sent();
                    if (pendingModel) {
                        return [2 /*return*/, pendingModel];
                    }
                    _a.label = 3;
                case 3:
                    if (!(environmentLoader && !environmentLoader.isLoaded())) return [3 /*break*/, 5];
                    return [4 /*yield*/, environmentLoader.load()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/, loadAndEvaluate_1.loadAndEvaluate({
                        fetcher: transport.fetchComponentsBundle,
                        id: id,
                        url: url,
                    })];
            }
        });
    });
}
exports.loadBundle = loadBundle;
function loadBundleComponents(transport, id, url, environmentLoader) {
    return __awaiter(this, void 0, void 0, function () {
        var content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadBundle(transport, id, url, environmentLoader)];
                case 1:
                    content = _a.sent();
                    if (!content || !content.components) {
                        throw RegistryError_1.createException('Incorrect bundle. There are no exported components', RegistryError_1.RegistryErrorCode.IncorrectBundleExport)
                            .withUrl(url)
                            .withHint('Probably library was bundled in a wrong way');
                    }
                    return [2 /*return*/, {
                            components: content.components,
                            info: content[editor_elements_conventions_1.BUNDLE_INFO_VARIABLE],
                        }];
            }
        });
    });
}
exports.loadBundleComponents = loadBundleComponents;
//# sourceMappingURL=loadBundle.js.map